import useMedia from 'syf-js-utilities/hooks/useMedia';
import mediaQueries from '../../../const/mediaQueries';
const Desktop = ({ children, query }) => useMedia([query !== null && query !== void 0 ? query : mediaQueries.greaterThanMedium], [true], false)
    ? children
    : null;
const Mobile = ({ children, query }) => useMedia([query !== null && query !== void 0 ? query : mediaQueries.lessThanMedium], [true], false)
    ? children
    : null;
export default { Desktop, Mobile };
